import type { Cta } from './types';

/** Header, footer and structured data shared by the public pages. */
export const shared = {
  skipLink: 'Skip to content',
  header: {
    homeLabel: 'Pairing by Denamico, home',
    menuLabel: 'Menu',
    navLabel: 'Main',
    links: [
      { label: 'For HubSpot reps', href: '/reps' },
      { label: 'Fit check', href: '/fit-check' },
      { label: 'Sign in', href: '/login' },
    ] satisfies Cta[],
    primary: { label: 'Talk to Denamico', href: '/#contact' } satisfies Cta,
    /** Shown instead of nothing, after hydration, when this browser holds a portal session. Not an automatic redirect. */
    portal: { label: 'Go to your portal', href: '/portal' } satisfies Cta,
  },
  footer: {
    /** The lockup links to the client page; with the next two links it covers the three public pages. */
    lockup: { label: 'Pairing by Denamico', href: '/' } satisfies Cta,
    navLabel: 'Footer',
    links: [
      { label: 'For HubSpot reps', href: '/reps' },
      { label: 'Fit check', href: '/fit-check' },
      { label: 'HubSpot app', href: '/hubspot-app' },
      { label: 'Security', href: '/security' },
      { label: 'Support', href: '/support' },
      { label: 'Sign in', href: '/login' },
      { label: 'Denamico', href: 'https://www.denamico.com' },
      { label: 'Privacy', href: 'https://www.denamico.com/privacy-policy' },
    ] satisfies Cta[],
    copyright: '© Denamico',
  },
  /** Dev-only labels for the pending and TODO markers; production never renders them. */
  dev: {
    pendingTag: 'pending',
    todoTag: 'TODO',
  },
  structuredData: {
    organization: {
      name: 'Denamico',
      url: 'https://www.denamico.com',
    },
    application: {
      name: 'Pairing by Denamico',
      category: 'BusinessApplication',
      operatingSystem: 'Web',
    },
  },
} as const;
